import React, { ReactNode } from "react";
import { Text } from "@puzzle/ve";
import { buttonContainerStyle } from "../launchpadBanner.css";

export type LeftSectionContentContainerProps = {
  description: string;
  children: ReactNode;
};

export const LeftSectionContentContainer = ({
  description,
  children,
}: LeftSectionContentContainerProps) => {
  return (
    <>
      <Text variant="headingS" color="neutral-moreSubdue" style={{ lineHeight: "26px" }}>
        <span dangerouslySetInnerHTML={{ __html: description }} />
      </Text>
      <div className={buttonContainerStyle}>{children}</div>
    </>
  );
};
